'use es6';

import { useCallback, useContext, useEffect, useState } from 'react';
import { getCurrencyInformation } from 'reporting-data/public/currency';
import StackedForecast from './StackedForecast';
import { checkCanReportOnRevenueQuotas, getQuotasTotal } from '../QuotaUtils';
import { createStageDrilldownReport, getForecastStages, getStagesTotal } from '../ForecastUtils';
import NoData from 'reporting-ui-components/components/shared/NoData';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { resolve } from 'reporting-data/main';
import { reportsEqual } from 'reporting-ui-components/lib/shallowCompareReports';
import CustomWidgetProps from 'reporting-ui-components/lib/CustomWidgetProps';
import ReportErrored from '../../../../reports/inferLogic/components/states/ReportErrored';
import { FiscalYearContext } from '../../../PlatformReport/FiscalYearProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const DealForecastViz = ({
  report,
  isMobile,
  noDataRenderer,
  onDrilldown,
  setIsRendered,
  onReportResolve,
  onError
}) => {
  const [currentReport, setCurrentReport] = useState(undefined);
  const [data, setData] = useState(null);
  const [settings, setSettings] = useState({});
  const [reportError, setReportError] = useState();
  const fiscalYearMonthName = useContext(FiscalYearContext);
  useEffect(() => {
    if ((!currentReport || !reportsEqual(report, currentReport)) && report) {
      setCurrentReport(report);
      Promise.all([getCurrencyInformation(), checkCanReportOnRevenueQuotas(), getQuotasTotal({
        report,
        fiscalYearMonthName
      }), resolve(report, {
        v2Datasets: true,
        newrelic: null
      })]).then(([{
        homeCurrency
      }, canReportOnRevenueQuotas, quotaTotal, resolveResponse]) => {
        setSettings({
          homeCurrency,
          canReportOnRevenueQuotas,
          quotaTotal
        });
        if (typeof setIsRendered === 'function') {
          setIsRendered();
        }
        setData(resolveResponse);
        if (onReportResolve) {
          onReportResolve({
            data: resolveResponse
          });
        }
      }).catch(error => {
        setReportError(error);
        if (onError) {
          onError(error);
        }
      });
    }
  }, [currentReport, report, setIsRendered, onReportResolve, onError, fiscalYearMonthName]);
  const onDrilldownDealForecast = useCallback((key, label) => {
    onDrilldown(createStageDrilldownReport(key, label, report));
  }, [onDrilldown, report]);
  if (reportError) {
    return /*#__PURE__*/_jsx(ReportErrored, {
      error: reportError,
      isMobile: isMobile
    });
  }
  if (!data || settings.homeCurrency === undefined || settings.canReportOnRevenueQuotas === undefined || settings.quotaTotal === undefined) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    });
  }
  const stages = getForecastStages(data);
  const total = getStagesTotal(stages);
  if (total === 0) {
    return noDataRenderer ? noDataRenderer() : /*#__PURE__*/_jsx(NoData, {});
  }
  const quota = settings.canReportOnRevenueQuotas && settings.quotaTotal > 0 ? settings.quotaTotal : null;
  const reportProps = {
    quota,
    currencyCode: settings.homeCurrency.currencyCode,
    stages,
    onDrilldown: onDrilldownDealForecast,
    total,
    isMobile
  };
  return /*#__PURE__*/_jsx(StackedForecast, Object.assign({}, reportProps));
};
DealForecastViz.propTypes = CustomWidgetProps;
export default DealForecastViz;